import { useEffect, useState } from 'react';

import styled from 'styled-components';
import { flexDirectionColumn, layerA } from 'shared/styles/commonStyles';

import TitleContainer from 'shared/components/TitleContainer';
import AuditTrailComponentBySwitch from './AuditTrailComponentBySwitch';
import ATMainSelect from './ATMainSelect';

import {
  extractUniquePropertyValues,
  formatTime,
  getLocationAssignedUsersByDeviceIds,
} from 'shared/helpers/helpers';
import { getAuditTrailService } from 'features/auditTrail/services/auditTrail.service';
import { useCheckControlPermsission, useLocations } from 'shared/hooks';

const AuditTrailMain = () => {
  const [isReadyToRender, setIsReadyToRender] = useState(false);
  const [userSelect, setUserSelect] = useState([]);
  const [auditTrailData, setAuditTrailData] = useState({});
  const checkSwitchPermission=useCheckControlPermsission();
  const locations = useLocations();
  const { all: allLocations } = locations;
  const [disableSettings, setDisableSettings] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const AUDIT_TRAIL_Action = [
    'MASTER_CONTROL',
    'GLOBAL_MASTER_CONTROL',
    'FAST_MASTER_CONTROL',
    'LOCAL_MASTER_CONTROL',
    'SSR_RESET',
    'THERMOCOUPLE_RESET',
    'GROUND_RESET',
    'HPLP_RESET',
    'LOAD_EXCEED_RESET',
    'TIMEOUT_RESET',
    'BMS_RESET',
    'GLOBAL_TELEMETRY_OVERVIEW',
    'ACTION',
  ];


  const componentsStatus = {
    ess: checkSwitchPermission('ess'),
    tgs: checkSwitchPermission('tgs'),
    tes: checkSwitchPermission('tes'),
    hp: checkSwitchPermission('hp'),
    ate: checkSwitchPermission('ate'),
    setting: true,
    aat: true,
  };


  const handleUserSelect = async (selectedData) => {


    const startDate = formatTime(selectedData[1].start, true);
    const endDate = formatTime(selectedData[1].end, true);
    if (selectedData[0]) {

      console.log(0);
      setUserSelect(selectedData);
      const userIds = extractUniquePropertyValues(selectedData[2], 'user_id');
      const AuditTrailPayload = (actionType = '', deviceType = '') => ({
        userIds,
        startDate,
        endDate,
        actionType: actionType,
        deviceType: deviceType,
      });
      const settingsByUesrnamePayload = {
        startDate,
        endDate,
        actionType: ['AUTH', 'SETTING', 'HEAT_CONFIGURATION'],
        userIds: userIds,
      };
      const additionalActionTakenByUsernamePayload = {
        startDate,
        endDate,
        userIds,
        actionType: ['GLOBAL_DATA_TELEMETRY_OVERVIEW', 'AUDIT_TRAIL'],
      };

      const allAduitTrail = {
        EssActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'ESS'),
          200
        ),
        EssFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'ESS'),
          200
        ),
        TesActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TES'),
          200
        ),
        TesFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TES'),
          200
        ),
        TgsActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TGS'),
          200
        ),
        TgsFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TGS'),
          200
        ),

        settings: getAuditTrailService(settingsByUesrnamePayload, 1000),

        additionalActionTaken: getAuditTrailService(
          additionalActionTakenByUsernamePayload,
          1000
        ),
      };
      setSearchQuery(AuditTrailPayload());

      const promises = Object.values(allAduitTrail);
      await Promise.all(promises)
        .then((results) => {
          let AduitTrailData = {
            ess: {
              actions: results[0],
              faults: results[1],
            },
            tes: {
              actions: results[2],
              faults: results[3],
            },
            tgs: {
              actions: results[4],
              faults: results[5],
            },
            setting: results[6],
            aat: results[7],
            hp: {},
            ate: {},
          };
          setAuditTrailData(AduitTrailData);
          setIsReadyToRender(true);
        })
        .catch((error) => {
          throw error;
        });
    } else {

      const deviceIds = extractUniquePropertyValues(selectedData[2], 'machine');
      setUserSelect(selectedData);
      const AuditTrailPayload = (actionType = '', deviceType = '') => ({
        deviceIds,
        startDate,
        endDate,
        actionType: actionType,
        deviceType: deviceType,
      });

      const settingsByLoctionPayload = {
        startDate,
        endDate,
        actionType: ['SETTING', 'HEAT_CONFIGURATION'],
        userIds: getLocationAssignedUsersByDeviceIds(deviceIds, allLocations),
      };
      const additionalActionTakenByLoctionPayload = {
        startDate,
        endDate,
        deviceIds,
        actionType: ['GLOBAL_DATA_TELEMETRY_OVERVIEW', 'AUDIT_TRAIL'],
      };

      const allAduitTrail = {
        EssActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'ESS'),
          200
        ),
        EssFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'ESS'),
          1000
        ),
        TesActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TES'),
          200
        ),
        TesFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TES'),
          1000
        ),
        TgsActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TGS'),
          200
        ),
        TgsFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TGS'),
          200
        ),
        settings: getAuditTrailService(settingsByLoctionPayload, 1000),
        additionalActionTaken: getAuditTrailService(
          additionalActionTakenByLoctionPayload,
          1000
        ),
      };
      setSearchQuery(AuditTrailPayload());

      const promises = Object.values(allAduitTrail);
      await Promise.all(promises)
        .then((results) => {
          let AduitTrailData = {
            ess: {
              actions: results[0],
              faults: results[1],
            },
            tes: {
              actions: results[2],
              faults: results[3],
            },
            tgs: {
              actions: results[4],
              faults: results[5],
            },
            setting: results[6],
            aat: results[7],
            hp: {},
            ate: {},
          };
          setAuditTrailData(AduitTrailData);
          setIsReadyToRender(true);
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  useEffect(() => {}, []);

  return (
    <Wrapper>
      <TitleContainer title='audit trail' />
      <ATMainSelect
        isReadyToRender={isReadyToRender}
        handleSelection={handleUserSelect}
        setDisableSettings={setDisableSettings}
      />
      <SectionMain>
        {Object.keys(componentsStatus).map((component, index) => {
          return (
            <AuditTrailComponentBySwitch
              key={index}
              componentName={component}
              isReadyToRender={isReadyToRender}
              active={componentsStatus[component]}
              userSelect={userSelect}
              data={auditTrailData[component] ?? {}}
              disableSettings={disableSettings}
              searchQuery={searchQuery}
            />
          );
        })}
      </SectionMain>
    </Wrapper>
  );
};

export default AuditTrailMain;

const Wrapper = styled.div`
  min-height: 674rem;
  width: 1216rem;
`;

const SectionMain = styled.section`
  width: 1216px;

  border-radius: 40px 40px 40px 40px;
  ${layerA}
  ${flexDirectionColumn}
  padding: 2px 0;
`;
